import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardType } from '@app/core/enums/dashboard-types.enum';

@Component({
  selector: 'app-contact-us-info',
  imports: [],
  templateUrl: './contact-us-info.component.html'
})
export class ContactUsInfoComponent implements OnChanges {

  @Input() dashboardType?: DashboardType;

  email = '';
  phone = '';
  fax = '';

  ngOnChanges(): void {
    switch (this.dashboardType) {
      case DashboardType.Referral:
        this.email = 'referrals@iowaortho.com';
        this.phone = '515-247-8400';
        this.fax = '515-362-7979';
        break;
      case DashboardType.WorkComp:
        this.email = 'workcomp@iowaortho.com';
        this.phone = '515-323-6408';
        this.fax = '515-362-7931';
        break;
      default:
        this.email = '';
        this.phone = '';
        this.fax = '';
        break;
    }
  }
}
